// External libraries
import styled from '@emotion/styled';

const Container = styled.div`
  border-radius: 24px;
  background: #f5f7fa;
  position: relative;

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  position: relative;
  min-height: 80px;
`;

const Spinner = styled.div`
  position: absolute;
  width: 40px;
  height: 40px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #0070ba;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: translateY(-50%) rotate(0deg);
    }

    100% {
      transform: translateY(-50%) rotate(360deg);
    }
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const List = styled.ul`
  background: inherit;
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const WalletOption = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  height: 72px;
  min-height: 72px;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  background: #f5f7fa;
  border: none;
  outline: none;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    background: #eef1f5;
  }

  &:focus-visible {
    outline: 2px solid #0070ba;
    outline-offset: -2px;
  }
`;

const WalletLogoWrap = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const WalletName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #000;
  line-height: 20px;
`;

const Separator = styled.div`
  height: 2px;
  margin: 0;
  background: #ffffff;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  background: #f5f7fa;
  width: 100%;
  box-sizing: border-box;
`;

const FooterText = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.63);
`;

const FooterLogo = styled.img`
  width: 50px;
  height: 14px;
  object-fit: contain;
`;

const AccordionHeader = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 16px;
  height: 72px;
  width: 100%;
  background: #f5f7fa;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #000;
  gap: 12px;
  text-align: left;
  box-sizing: border-box;

  &:hover {
    background: #eef1f5;
  }

  &:focus-visible {
    outline: 2px solid #0070ba;
    outline-offset: -2px;
  }

  &[aria-expanded='true'] .chevron {
    transform: rotate(180deg);
  }

  &[aria-expanded='true'] .ppw-icon {
    width: 0;
    opacity: 0;
    margin-right: -12px;
  }

  &[aria-expanded='true'] .ppw-description {
    max-height: 0;
    opacity: 0;
    margin-top: -2px;
  }
`;

const Chevron = styled.svg`
  margin-left: auto;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  transition: transform 0.2s;
  color: rgba(0, 0, 0, 0.63);
`;

const PpwIcon = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  opacity: 1;
  overflow: hidden;
  border-radius: 50%;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    width 0.25s ease,
    opacity 0.25s ease,
    margin-right 0.25s ease;

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
`;

const PpwHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

const PpwLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #000;
  line-height: 20px;
`;

const PpwDescription = styled.span`
  font-size: 13px;
  color: rgba(0, 0, 0, 0.63);
  line-height: 18px;
  max-height: 18px;
  opacity: 1;
  overflow: hidden;
  transition:
    max-height 0.25s ease,
    opacity 0.25s ease,
    margin-top 0.25s ease;
`;

const AccordionBodyWrap = styled.div<{ isOpen: boolean }>`
  display: grid;
  grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
  transition: grid-template-rows 0.25s ease;
`;

const AccordionBody = styled.ul`
  background: inherit;
  overflow: hidden;
  min-height: 0;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export {
  Container,
  SpinnerContainer,
  Spinner,
  CardsWrapper,
  List,
  WalletOption,
  WalletLogoWrap,
  WalletName,
  Separator,
  Footer,
  FooterText,
  FooterLogo,
  AccordionHeader,
  Chevron,
  PpwIcon,
  PpwHeaderText,
  PpwLabel,
  PpwDescription,
  AccordionBodyWrap,
  AccordionBody,
};
